import { useUsefulLinks } from "@/hooks/useUsefulLinks";
import { useUsefulLinkTypes } from "@/hooks/useUsefulLinkTypes";
import cn from "classnames";
import { Accordion, Col, Container, Row } from "react-bootstrap";

import classes from "./styles.module.scss";

export default function ({ className, EditableText }) {
  const links = useUsefulLinks();
  const types = useUsefulLinkTypes();

  return (
    <div className={cn(className, classes.UsefulLinks)}>
      <Container>
        <div className="mb-4">
          <EditableText path="text">
            Here are some links you may find useful throughout your job search.
          </EditableText>
        </div>
        <Accordion className="mb-5">
          {types.map((type) => (
            <Accordion.Item eventKey={type}>
              <Accordion.Header>{type}</Accordion.Header>
              <Accordion.Body>
                {links
                  .filter((i) => i.type === type)
                  .map((link) => (
                    <Row className="mb-3">
                      <Col xs={12} md={5}>
                        {link.title}
                      </Col>
                      <Col xs={12} md={7} className="border-start">
                        <a href={link.url} target="_blank" rel="noopener noreferrer">
                          {link.url.replaceAll("https://", "")}
                        </a>
                      </Col>
                      {link.image && (
                        <Col xs={12}>
                          <img className="mt-3" src={link.image} alt="" />
                        </Col>
                      )}
                      {link.description && (
                        <Col xs={12} className="ps-0 mt-3">
                          <em>{link.description}</em>
                        </Col>
                      )}
                    </Row>
                  ))}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Container>
    </div>
  );
}
